import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import Switch from 'react-switch';

import { toggleModal } from '../../actions/modalActions';
import {
    getDevices,
    setCurrentDevice,
    getRecipients,
    addRecipient,
    removeRecipient,
    toggleReports,
} from '../../actions/deviceActions';

import Modal from './Modal';

class ReportsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            emailError: '',
            device: null,
        };
    }

    componentDidUpdate(prevProps) {
        if ((this.props.deviceId && (this.props.deviceId !== prevProps.deviceId ||
            (!this.props.devicesLoading && prevProps.devicesLoading)))) {
            this.props.getRecipients(this.props.deviceId);
            const { devices, deviceId } = this.props;
            const [device] = devices.filter(item => item.id === deviceId);

            this.setState({
                device,
            });
        }
    }

    validateEmail(email) {
        const reg = new RegExp([
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))/.source,
            /@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.source,
        ].join(''));

        return email.length >= 2 && email.length <= 180 && reg.test(email);
    }

    onClose = () => {
        this.setState({
            email: '',
            emailError: '',
        });
        this.props.toggleModal('reportsModal');
        this.props.setCurrentDevice(null);
    }

    onEmailAdd = () => {
        const { email } = this.state;

        if (!email) {
            return;
        }

        if (!this.validateEmail(email)) {
            return this.setState({
                emailError: 'dashboard.modals.reports.email.error.invalid'
            });
        }

        const emails = this.props.recipients.map(item => item.recipient_email);

        if (emails.filter(item => item === email).length !== 0) {
            return this.setState({
                emailError: 'dashboard.modals.reports.email.error.added'
            });
        }

        this.props.addRecipient(this.props.deviceId, { recipient_email: this.state.email })
            .then(() => this.props.getRecipients(this.props.deviceId));

        this.setState({
            email: '',
            emailError: '',
        });
    }

    onEmailChange = (e) => {
        this.setState({ email: e.target.value });
    }

    removeEmail(recipientId) {
        this.props.removeRecipient(this.props.deviceId, recipientId)
            .then(() => this.props.getRecipients(this.props.deviceId));
    }

    renderItems() {
        const { recipients, recipientsError } = this.props;

        if (recipientsError || !recipients || recipients.length === 0) {
            return;
        }

        return (
            <ul className="simple-list">
                {recipients.map(item => {
                    return (
                        <li className="my-3" key={item.id}>
                            <div className="d-flex justify-content-between align-content-center">
                                <span>{item.recipient_email}</span>
                                <i className="fa fa-trash action-icon" onClick={() => this.removeEmail(item.id)}></i>
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }

    onSubmit = (sendReports) => {
        this.props.toggleReports(this.props.deviceId, { send_reports: !sendReports })
            .then(() => this.props.getDevices());
    }

    renderSwitch(sendReports) {
        const disabled = !sendReports && (!this.props.recipients || this.props.recipients.length === 0);

        return (
            <label>
                <Switch
                    className="mt-3"
                    onChange={() => this.onSubmit(sendReports)}
                    checked={sendReports}
                    onColor="#ddd"
                    offHandleColor="#ddd"
                    onHandleColor="#3d8ea7"
                    handleDiameter={30}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    disabled={disabled}
                />
            </label>
        );
    }

    render() {
        const { emailError, device } = this.state;

        if (!device) {
            return null;
        }

        const { modals, deviceId } = this.props;
        const show = modals.includes('reportsModal');
        const sendReports = device.send_reports;

        return (
            <Modal
                show={show}
                title={<FormattedMessage id="dashboard.modals.reports.title"/>}
                onClose={this.onClose}
                submitCaption={<FormattedMessage id="dashboard.modals.reports.submit" />}
                closeCaption={<FormattedMessage id="dashboard.modals.reports.cancel" />}
                onSubmit={this.onClose}
                headerExtraContent={this.renderSwitch(sendReports)}
            >
                {
                    emailError &&
                    <div className="invalid-feedback d-block mb-4"><FormattedMessage id={emailError} /></div>
                }
                <div className="d-flex justify-content-between mt-3 mb-2">
                    <input
                        type="email"
                        id={deviceId}
                        value={this.state.email}
                        className="form-control"
                        onChange={this.onEmailChange}
                    />
                    <button type="button" className="btn btn-primary btn--fixed-width ml-4" onClick={this.onEmailAdd}>
                        <FormattedMessage id="dashboard.modals.reports.email.add" />
                    </button>
                </div>
                <p className="py-2"><FormattedMessage id="dashboard.modals.reports.info" /></p>
                <hr />
                <p className="pt-2 mb-0">
                    <strong><FormattedMessage id="dashboard.modals.reports.header" /></strong>
                </p>
                <Scrollbars style={{ height: '120px' }}>
                    {this.renderItems()}
                </Scrollbars>
            </Modal>
        );
    }
}

export default connect(
    (state) => ({
        devices: state.device.data.list,
        devicesLoading: state.device.data.loading,
        deviceId: state.device.current,
        modals: state.modals,
        recipients: state.device.recipients.list,
        recipientsError: state.device.recipients.error,
        deviceToggleLoading: state.device.toggle.loading,
    }),
    ({ toggleModal, getDevices, setCurrentDevice, getRecipients, addRecipient, removeRecipient, toggleReports })
)(ReportsModal);



// WEBPACK FOOTER //
// ./src/components/Modal/ReportsModal.js